"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WholesaleVerificationSchema = exports.WHOLESALE_EXPIRY_NOT_AFTER_VERIFICATION = exports.WHOLESALE_NOTES_MAX_LENGTH = void 0;
const yup = __importStar(require("yup"));
exports.WHOLESALE_NOTES_MAX_LENGTH = 2000;
exports.WHOLESALE_EXPIRY_NOT_AFTER_VERIFICATION = "Expiry date must be after the date verified";
exports.WholesaleVerificationSchema = yup.object().shape({
    verificationDate: yup.date().nullable().optional(),
    expiryDate: yup
        .date()
        .nullable()
        .optional()
        .test("expiry-after-verification", exports.WHOLESALE_EXPIRY_NOT_AFTER_VERIFICATION, function expiryAfterVerification(value) {
        const { verificationDate } = this.parent;
        if (!value || !verificationDate) {
            return true;
        }
        return value.toISOString().slice(0, 10) > verificationDate.toISOString().slice(0, 10);
    }),
    notes: yup.string().trim().max(exports.WHOLESALE_NOTES_MAX_LENGTH).nullable().optional(),
});
//# sourceMappingURL=WholesaleVerification.js.map